diy.angular.registerFactory('diyfmstatus', ['diyfmuploadqueue', 'diyfminsertprogress', function(diyfmuploadqueue, diyfminsertprogress) {
    return {
        getCurrentStatus: function() {
            var status = [];

            if (diyfmuploadqueue.get('storageFiles').getInProgressCount()) {
                status.push('upload');
            }

            if (diyfminsertprogress.isShown()) {
                status.push('insert');
            }

            return status;
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmstatus.js
 ** module id = 943
 ** module chunks = 0
 **/